var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuesTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1613_20649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20039 5.99999L5.60039 7.99999L8.80039 3.99999M6.00039 11.6C5.26499 11.6 4.53679 11.4551 3.85736 11.1737C3.17794 10.8923 2.5606 10.4798 2.04059 9.95979C1.52058 9.43978 1.10809 8.82244 0.826665 8.14302C0.545239 7.4636 0.400391 6.7354 0.400391 5.99999C0.400391 5.26459 0.545239 4.53639 0.826665 3.85697C1.10809 3.17754 1.52058 2.5602 2.04059 2.0402C2.5606 1.52019 3.17794 1.10769 3.85736 0.826268C4.53679 0.544842 5.26499 0.399994 6.00039 0.399994C7.4856 0.399994 8.90998 0.989992 9.96019 2.0402C11.0104 3.0904 11.6004 4.51478 11.6004 5.99999C11.6004 7.48521 11.0104 8.90959 9.96019 9.95979C8.90998 11.01 7.4856 11.6 6.00039 11.6Z",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1613_20649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuesTick);
export default __webpack_public_path__ + "static/media/ques-tick.99d109ba047c238d1626cba5bd947b4f.svg";
export { ForwardRef as ReactComponent };